import React from 'react'
import { Paper, withStyles, Grid, TextField, Button, FormControlLabel, Checkbox } from '@material-ui/core'
import { Face, Fingerprint } from '@material-ui/icons'
import axios from 'axios'
import axiosCookieJarSupport from 'axios-cookiejar-support'
import { setSelectedModule } from '../redux/navigation'
import {theme} from '../theme'
import { baseApiAuth } from "../modules/db";

axiosCookieJarSupport(axios)
 

const styles = theme => ({
    margin: {
        margin: 10,
    },
    padding: {
        padding: 5
    }
})

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: "org.couchdb.user:",
            first_name: "",
            last_name: "",
            username: "",
            password: "",
            passwordConf:"",
            type: "user",
            roles: ["haccpwriter"],
            email:""
        };
      }
    doSignUp = () => {
        const newUser = {...this.state}
        if(newUser.email==""){
            alert('Please add a valid email')
        }
        if(newUser.first_name==""){
            alert('Please add a valid name')
        }
        if(newUser.last_name==""){
            alert('Please add a valid last name')
        }
        if(newUser.email!=""&&newUser.first_name!=""&&newUser.last_name!=""){
            if(newUser.password === newUser.passwordConf){
                axios.post(`${baseApiAuth}/register`, newUser)
                .then(function (response) {
                    console.log(response)   
                    if(response.status===200){
                        alert('Welcome, your account was successfully created but is need to be verified. Please check your email and confirm the account before login')
                        setSelectedModule('Login')
                        alert('Your account was sucessfully created')
                    }
                    else{
                        alert("Check your data!")
                        this.setState({
                            first_name: "",
                            last_name: "",
                            password: "",
                            email:""
                        })
                    }
                }).catch((err) => {
                    alert("your credentials are not possible to register, please verify them")

                })}else{
                    alert('Verify that you enter the same text under password and password confirmation ')
                }
        }
        
    }

    doLogin = () => {
        setSelectedModule('Login')
    }

    handleFormChange = (event) => {
        let res = {...this.state}
        res[event.target.id]=event.target.value
        /*if(!(event.target.id==='email')){
            res[event.target.id]=event.target.value
        }
        else{
            //res['_id']= 'org.couchdb.user:'+event.target.value
            res['email']= event.target.value
            res['firstname']=event.target.value
            res['lastname']=event.target.value
        }*/
        this.setState(res)
    };

    render() {
        const { classes } = this.props
        const { colors } = theme
        return (
            <Paper 
                className={classes.padding} 
                style={{ 
                    color: colors.secondary
                }}
            >
                <div className={classes.margin}>
                    <Grid container spacing={8} alignItems="flex-end">
                        <Grid item>
                            <Face />
                        </Grid>
                        <Grid item md={true} sm={true} xs={true}>
                            <TextField   
                                id="first_name" 
                                label="First name"
                                fullWidth autoFocus required 
                                value={this.state.firstname} 
                                onChange={this.handleFormChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={8} alignItems="flex-end">
                        <Grid item>
                            <Face />
                        </Grid>
                        <Grid item md={true} sm={true} xs={true}>
                            <TextField   
                                id="last_name" 
                                label="Last name"
                                fullWidth autoFocus required 
                                value={this.state.lastname} 
                                onChange={this.handleFormChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={8} alignItems="flex-end">
                        <Grid item>
                            <Face />
                        </Grid>
                        <Grid item md={true} sm={true} xs={true}>
                            <TextField   
                                id="email" 
                                label="Email" 
                                fullWidth autoFocus required 
                                value={this.state.email} 
                                onChange={this.handleFormChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={8} alignItems="flex-end">
                        <Grid item>
                            <Fingerprint />
                        </Grid>
                        <Grid item md={true} sm={true} xs={true}>
                            <TextField  id="password" label="Password" type="password" fullWidth required 
                            value={this.state.password} 
                            onChange={(e) => this.handleFormChange(e)}
                    />
                        </Grid>
                    </Grid>
                    <Grid container spacing={8} alignItems="flex-end">
                        <Grid item>
                            <Fingerprint />
                        </Grid>
                        <Grid item md={true} sm={true} xs={true}>
                            <TextField  id="passwordConf" label="Confirmation" type="password" fullWidth required 
                            value={this.state.passwordConf} 
                            onChange={(e) => this.handleFormChange(e)}
                    />
                        </Grid>
                    </Grid>
                    <Grid container justify="center" style={{ marginTop: '10px' }}>
                        <Button 
                            variant="outlined" 
                            style={{ 
                                color: colors.primary, 
                                backgroundColor: colors.light,
                                marginRight:30
                              }}
                            onClick={this.doLogin}
                        >Login</Button>
                        <Button 
                            variant="contained" 
                            style={{ 
                                backgroundColor: colors.secondary, 
                                color: colors.light
                              }}
                            onClick={this.doSignUp}
                        >Sign Up</Button>
                    </Grid>
                </div>
            </Paper>
        )
    }
}

export default withStyles(styles)(Login)